import { useLanguage } from "../i18n/LanguageContext";
import FitnessTraining from "../elements/FitnessTraining";

const Gallery = () => {
  const { t } = useLanguage();
  return (
    <div className="hpa-dark-panel-content">

      {/* Section title */}
      <div className="section-head style-1 text-center mb-5">
        <h2 className="title">
          {t("Exercise Libraries")}
        </h2>
        <p className="p-big mx-auto" style={{ maxWidth: "600px" }}>
          {t("Explore structured training systems designed to organise strength, performance, and mobility exercises.")}
        </p>
      </div>

      <FitnessTraining />

    </div>
  );
};

export default Gallery;
